import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const categories = [{
  id: 'wire-edm-traditional',
  title: 'Wire EDM Traditional',
  image: 'https://cdn.magicpatterns.com/uploads/dY5MTF4GLWn7rmMMgQpwHL/Wire_EDM_Traditional.jpg',
  summary: 'The largest selection of Wire EDMs on the market. CHMER EDM offers ball screw and linear motor drives with glass scale feedback, flushing and submerged configurations, and 6-axis CNC controls across G, GX, RX, RV, RQ, and AW series.',
  href: '/EDMNetworkWireEDM.html'
}, {
  id: 'sinker-edm',
  title: 'Sinker EDM',
  image: 'https://cdn.magicpatterns.com/uploads/5WABWbM2ch5kJ55bhuTBiy/Sinker_EDM.jpg',
  summary: 'Precision die-sinking EDM machines for complex 3D cavities and intricate geometries in hardened materials. Ideal for mold, die, and tooling applications requiring fine surface finishes and tight tolerances.',
  href: '/EDMNetworkSinker.html'
}, {
  id: 'driller-edm',
  title: 'Driller EDM',
  image: 'https://cdn.magicpatterns.com/uploads/etdsMccoeKvguvCa49DzLt/Driller_EDM.jpg',
  summary: 'High-precision CNC EDM drilling machines for creating small, deep holes in conductive materials. Widely used in aerospace, medical, and tooling applications with multi-axis automation capabilities.',
  href: '/EDMNetworkDriller.html'
}, {
  id: 'linear-motor-cnc-milling',
  title: 'Linear Motor CNC Milling',
  image: 'https://cdn.magicpatterns.com/uploads/766GQZXgHocjToBwA1QdjU/Linear_Motor_CNC_Milling.jpg',
  summary: 'Advanced CNC milling machines powered by linear motor drives for ultra-fast movement, high precision, and minimal backlash. Optimized for high-speed machining of graphite, hard metals, and precision tooling components.',
  href: '/EDMNetworkLinearMilling.html'
}, {
  id: 'diamond-abrasive-saw',
  title: 'Diamond Abrasive Saw',
  image: 'https://cdn.magicpatterns.com/uploads/c9AbrHcYHH7y8FER9wWbMv/Diamond_Abrasive_Saw.jpg',
  summary: 'A 2-axis CNC cutting system using diamond-coated wire to cut non-conductive materials such as composites, graphite, ceramics, glass, and stone. Offers precise, economical cutting for materials that cannot be machined using EDM processes.',
  href: '/EDMNetworkDiamondSaw.html'
}];
export function CategoryCardsSection() {
  return <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-2079">
      {categories.map(category => <a key={category.id} href={category.href} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col sm:flex-row no-underline h-full" data-id="element-2080">
          <div className="sm:w-2/5 bg-gray-50 p-6 flex items-center justify-center border-b sm:border-b-0 sm:border-r border-gray-100 min-h-[250px]" data-id="element-2081">
            <img src={category.image} alt={category.title} className="max-w-full max-h-[200px] object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-2082" />
          </div>
          <div className="sm:w-3/5 p-8 flex flex-col" data-id="element-2083">
            <h2 className="text-2xl font-bold text-navy mb-4 group-hover:text-orange transition-colors" data-id="element-2084">
              {category.title}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6 flex-grow" data-id="element-2085">
              {category.summary}
            </p>
            <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-2086">
              <span className="inline-flex items-center text-orange font-bold text-sm group-hover:text-navy transition-colors" data-id="element-2087">
                Learn More
                <ArrowRightIcon className="w-4 h-4 ml-1.5 group-hover:translate-x-1 transition-transform" data-id="element-2088" />
              </span>
            </div>
          </div>
        </a>)}
    </div>;
}